import { useEffect, useState, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { ApiRequest, ShowLoader } from 'GlobalFunctions';
import getOrderDetails from '../Orders/getOrderDetails';
import StripeForm from './Utils/StripeForm';
// import Shipping from './Utils/Shipping';
import { getShippingMethods } from './Utils/Shipping';
import ClientForm from './ClientForm';
import { enqueueSnackbar, useSnackbar } from "notistack";
import DefaultForm from './Utils/DefaultForm';
import { CreditCard, PaymentForm } from 'react-square-web-payments-sdk';
import { ProjectConfig } from 'Global';
import POForm from './Utils/POForm';
import AutocompleteCities from '../../utils/AutocompleteCities';
import { validateLogic } from 'utils/logicValidator';
import {executeCustomLogicCode} from './Utils/CustomCode';
import { getTaxes } from 'components/Subscription/Subscription';
import { getTaxesPercentage } from './Utils/Taxes';

const defaultValues = {
    fname: "",
    lname: "",
    address: "",
    address2: "",
    postal: "",
    country: "",
    state: "",
    city: "",
    city_id: "",
    
    s_fname: "",
    s_lname: "",
    s_address: "",
    s_address2: "",
    s_postal: "",
    s_country: "",
    s_state: "",
    s_city: "",
    s_city_id: "",

    email: "",
    phone: "",
    isValidEmail: false,
    isValidPhone: false,
    
    sameShippingBilling: false,
    checkTerms: false,
    shipping_id: null,
    
}

export default function Checkout() {

    const [formValues, setFormValues] = useState(defaultValues);
    const paymentFormRootRef = useRef<any>(null); 
    const [initialized, setInitialized] = useState(false);

    const checkTaxesAndShipping = async () => {
        await getShippingMethods();
        getTaxesPercentage();
        await executeCustomLogicCode(() => getOrderDetails("checkout"));
    }

    const initialization = async () => {
        await getOrderDetails("checkout");
        await checkTaxesAndShipping();
        
        setInitialized(true);
    }


    useEffect(() => {
        if (!initialized) {
            const storeConfiguration = JSON.parse(localStorage.getItem('storeConfiguration') || '{}');

            
            console.log("storeConfiguration!", storeConfiguration);
            

            //ENABLE CONTINUE BUTTON
            const button = document.querySelector('[pc-step="accordion-next"]') as HTMLElement;
            button.classList.remove('is-disabled');

            
            /*=========================================================
            CHECK IF ORDER ID EXISTS
            =========================================================*/

            const orderStatus = document.querySelector('[pc-step="status"]');
            orderStatus?.classList.add('hidden');

            //config order-status-back-button 
            const orderStatusBackButton = document.querySelector('[pc="status-back"]');
            orderStatusBackButton?.addEventListener("click", () => {
                window.location.href = '/';
            });

            //CHANGE COMPANY NAME ON TERMS AND CONDITIONS
            const companyElement = document.querySelector('[pc="company"]');
            if (companyElement) { 
                companyElement.textContent = storeConfiguration?.data?.store?.store_name || "";
            }
            
            // Set up the accordion functionality
            setUpAccordion()
            initialization()
        }
    }, [initialized]);

    // Separate useEffect for cart:updated event listener to ensure it's always active
    useEffect(() => {
        // Add event listener for cart updates
        const handleCartUpdated = () => {
            getPaymentForm();
        };

        document.addEventListener('cart:updated', handleCartUpdated);

        // Clean up the event listener when component unmounts
        return () => {
            document.removeEventListener('cart:updated', handleCartUpdated);
        };
    }, []); // Empty dependency array to ensure this runs only once
    


    /*=========================================================
    SET PAYMENT STATUS
    =========================================================*/
    const setPaymentStatus = (data: any) => {

        const { status, message, order_id = null } = data;

        console.log("setPaymentStatus", data);
        enqueueSnackbar(message, { variant: status });

        if(status === 'success') {
            
            const elements = document.querySelectorAll('[pc-hide]');
            elements.forEach(element => {
                element.classList.add('hidden');
            });

            //change order-status-title to "Order # ${order_id} completed"
            const orderStatusTitle = document.querySelector('[pc="status-heading"]');
            if(orderStatusTitle) {
                orderStatusTitle.textContent = `Order # ${order_id} completed`;
            }
            
            const orderStatus = document.querySelector('[pc-step="status"]');
            orderStatus?.classList.remove('hidden');

            /*DELETE LOCALSTORAGE*/
            localStorage.clear()
        }
    }


    const buildPaymentForm = async (payment_info: any, cart: any) => {
        if (Object.keys(payment_info).length !== 0) {
            const paymentForm = document.querySelector('[pc="payment-form"]');
            if (paymentForm) {
                if (!paymentFormRootRef.current) {
                    paymentFormRootRef.current = createRoot(paymentForm);
                }
                const logicResult: any = await validateLogic({cart, logicMethod: 'purchase_order'});
                paymentFormRootRef.current.render(
                    <>
                        {logicResult.purchase_order? (
                            <POForm
                                payment_method={"purchase_order"}
                                setPaymentStatus={setPaymentStatus}
                                enqueueSnackbar={enqueueSnackbar}
                                ShowLoader={ShowLoader}
                            />
                        ) : (
                            <>
                            {payment_info.payment_method === 'stripe' && (
                            <StripeForm 
                                payment_settings={payment_info.payment_settings} 
                                setPaymentStatus={setPaymentStatus}
                            />
                            )}

                            {(
                                payment_info.payment_method === 'elavon' || 
                                payment_info.payment_method === 'authorize_net' ||
                                payment_info.payment_method === 'test_mode' ||
                                payment_info.payment_method === 'free'
                            ) && (
                                <DefaultForm
                                    payment_method={payment_info.payment_method}
                                    setPaymentStatus={setPaymentStatus}
                                    enqueueSnackbar={enqueueSnackbar}
                                    ShowLoader={ShowLoader}
                                />
                            )}
                            

                            {payment_info.payment_method === 'square' &&
                                <PaymentForm 
                                    applicationId = {ProjectConfig.SQUARE_CLIENT_ID}
                                    cardTokenizeResponseReceived={async (token, verifiedBuyer) => {
                                        ShowLoader(true)

                                        const cart = JSON.parse(localStorage.getItem('cart') || '{}');

                                        await ApiRequest({
                                            url: "/payments/defaultCheckout",
                                            method: "post",
                                            body: {
                                                cart,
                                                sourceId: token.token,
                                                payment_method: payment_info.payment_method
                                            },
                                            setResponse: (response: any) => {
                                                setPaymentStatus(response);
                                            }
                                        });
                                        ShowLoader(false)


                                    } }
                                    locationId='LBB7R4DKKTWBG'
                                >
                                    <CreditCard />
                                </PaymentForm>
                            }
                            </>
                        )}
                    </>
                );
            }
        }
        
    }

    /*=========================================================
    PAYMENT FORM
    =========================================================*/
    // useEffect(() => {
    //     buildPaymentForm();
    // }, [payment_info]);



    const getPaymentForm = async () => {
        const cart = JSON.parse(localStorage.getItem('cart') || '{}');

        // Control visibility of payment message element
        



        await ApiRequest({
            url: "/payments/getPaymentForm",
            method: "POST",
            body: {
                cart
            },
            setResponse: async (response: any) => {
                if(response.status==='error') {
                    enqueueSnackbar(response.message, { variant: 'error' });
                    return
                }
                console.log("Payment Form Response", response);
                buildPaymentForm(response, cart);

                const paymentMessageElement = document.querySelector('[pc="payment-message"]');
                if (paymentMessageElement) {
                    console.log("CHECKING Payment Method:", response.payment_method);
                    if (response.payment_method === "free") {
                        paymentMessageElement.classList.remove('hidden_object');
                    } else {
                        console.log("Hiding payment message for method:");
                        paymentMessageElement.classList.add('hidden_object');
                    }
                }
                
            },
        });
        
    };

    const setUpAccordion = () => {
        const accordionItems = document.querySelectorAll('[pc-acc="item"]');
    
        // HIDE ALL EXCEPT THE FIRST
        accordionItems.forEach((item, index) => {
            const title = item.querySelector('[pc="accordion-heading"]') as HTMLElement;
            if (index !== 0) {
                Array.from(item.children).forEach(child => {
                    if (child !== title && child instanceof HTMLElement) {
                        child.style.display = 'none';
                    }
                });
                // title?.classList.add('disabled');
            } else {
                title?.classList.add('active');
            }
        });
    
        // CLICK EVENT FOR ACCORDION TITLE
        document.querySelectorAll('[pc="accordion-heading"]').forEach(title => {
            // Check if the title has the 'disabled' class to prevent click
            if (!title.classList.contains('disabled')) {
                title.addEventListener('click', event => {
                    const clickedTitle = event.currentTarget as HTMLElement;
                    const accordionItem = clickedTitle.closest('[pc-acc="item"]') as HTMLElement;
    
                    // Toggle visibility
                    if (clickedTitle.classList.contains('active')) {
                        clickedTitle.classList.remove('active');
                        Array.from(accordionItem.children).forEach(child => {
                            if (child !== clickedTitle && child instanceof HTMLElement) {
                                child.style.display = 'none';
                            }
                        });
                    } else {
                        clickedTitle.classList.add('active');
                        Array.from(accordionItem.children).forEach(child => {
                            if (child instanceof HTMLElement) {
                                child.style.display = 'block';
                            }
                        });
                    }
    
                    // Hide all siblings of the other accordion items
                    accordionItems.forEach(item => {
                        if (item !== accordionItem) {
                            const otherTitle = item.querySelector('[pc="accordion-heading"]') as HTMLElement;
                            otherTitle?.classList.remove('active');
                            Array.from(item.children).forEach(child => {
                                if (child !== otherTitle && child instanceof HTMLElement) {
                                    child.style.display = 'none';
                                }
                            });
                        }
                    });
                });
            }
        });
    
        // CLICK EVENT FOR ACCORDION BUTTON
        document.querySelectorAll('[pc-step="accordion-next"]').forEach(button => {
            button.addEventListener('click', async event => {

                const incompleteFields = await isFormComplete();
                if (incompleteFields.incompleteFields.length > 0) {
                    enqueueSnackbar("Required fields are missing: " + incompleteFields.incompleteFields.join(", "), { variant: 'error' });
                    return;
                }

                const accordionItem = (event.currentTarget as HTMLElement).closest('[pc-acc="item"]') as HTMLElement;
                const title = accordionItem.querySelector('[pc="accordion-heading"]') as HTMLElement;
    
                // Hide current item
                Array.from(accordionItem.children).forEach(child => {
                    if (child !== title && child instanceof HTMLElement) {
                        child.style.display = 'none';
                    }
                });
                title?.classList.remove('active');
    
                // Show the next item
                const nextAccordionItem = accordionItem.nextElementSibling as HTMLElement;
                if (nextAccordionItem) {
                    Array.from(nextAccordionItem.children).forEach(child => {
                        if (child instanceof HTMLElement) {
                            child.style.display = 'block';
                        }
                    });
                    nextAccordionItem.querySelector('[pc="accordion-heading"]')?.classList.add('active');
                }
            });
        });
    };


    const [allFieldsFilled, setAllFieldsFilled] = useState(false);
    const isFormComplete = async () => {
        let incompleteFields: string[] = [];

        const cart = JSON.parse(localStorage.getItem('cart') || '{}');
        const client = cart.client || {};

        const {
            fname,
            lname,
            address,
            postal,
            country,
            state,
            city,
            email,
            phone,
            checkTerms,
            sameShippingBilling,
            s_fname,
            s_lname,
            s_address,
            s_postal,
            s_country,
            s_state,
            s_city,
            isValidEmail,
            isValidPhone
        } = client;

        if (fname === "") incompleteFields.push("First Name");
        if (lname === "") incompleteFields.push("Last Name");
        if (address === "") incompleteFields.push("Address");
        if (postal === "") incompleteFields.push("Postal Code");
        if (country === "") incompleteFields.push("Country");
        if (state === "") incompleteFields.push("State");
        if (city === "") incompleteFields.push("City");
        if (!checkTerms) incompleteFields.push("Terms and Conditions");
        if (!isValidEmail) incompleteFields.push("Invalid Email");
        if (!isValidPhone) incompleteFields.push("Invalid Phone");

        if (!sameShippingBilling) {
            if (s_fname === "") incompleteFields.push("Shipping First Name");
            if (s_lname === "") incompleteFields.push("Shipping Last Name");
            if (s_address === "") incompleteFields.push("Shipping Address");
            if (s_postal === "") incompleteFields.push("Shipping Postal Code");
            if (s_country === "") incompleteFields.push("Shipping Country");
            if (s_state === "") incompleteFields.push("Shipping State");
            if (s_city === "") incompleteFields.push("Shipping City");
        }

        if (!cart.shipping) incompleteFields.push("Shipping Method");

        // Verifica si hay error de impuestos en localStorage
        const taxError = localStorage.getItem('tax_error');
        if (taxError) {
            incompleteFields.push(`Tax Calculation Error: ${taxError}`);
        }

        setAllFieldsFilled(incompleteFields.length === 0);
        
        return {
            incompleteFields
        };
    };

    


    useEffect(() => {
        enableDisableAccordion(allFieldsFilled);
    }, [allFieldsFilled]);


    const enableDisableAccordion = (allFieldsFilled: boolean) => {
        const accordion = document.querySelector('[pc-step="payment"]');
        if (accordion) {
            const title = accordion.querySelector('[pc="accordion-heading"]') as HTMLElement;
            // const button = document.querySelector('[pc-step="accordion-next"]') as HTMLElement;
            if (title) {
                if (allFieldsFilled) {
                    title.classList.remove('disabled');
                }
                else {
                    title.classList.add('disabled');
                }
            }
        }
    }

    return (
        <>  
            
            <ClientForm
                formValues={formValues}
                setFormValues={setFormValues}
                checkTaxesAndShipping={checkTaxesAndShipping}
            />

            <div id="city_list">
                <AutocompleteCities 
                    formValues={formValues}
                    setFormValues={setFormValues}
                    pc_city="city"
                    pc_state="state"
                />
                <AutocompleteCities 
                    formValues={formValues}
                    setFormValues={setFormValues}
                    pc_city="s-city"
                    pc_state="s-state"
                />
            </div>
            
        </>
    )
}
